import type { TagValues } from 'magpie-types/tags';
import type { IConnectionStrategy } from '../../connection/abstract-connection-strategy';
import type { ConnectionError } from '../../errors';
import { ConnectionSpec } from '../../connection/connection-spec';

export interface ConfigProperties {
  portalId: string | null;
  appName: string;
  tags: TagValues;
  labels: Map<string, ReadonlySet<string>>;
  strategy: IConnectionStrategy | undefined;
  debug: boolean;
  forceReload: boolean;
  onConnectionError:
    | ((error: InstanceType<typeof ConnectionError>) => void)
    | undefined;
}

export type ConfigKey = keyof ConfigProperties;

export const fromConnectionSpec = (
  spec: Partial<ConnectionSpec>
): Partial<ConfigProperties> => {
  if (!('portalId' in spec)) {
    return spec as Partial<ConfigProperties>;
  }
  return {
    ...spec,
    portalId: spec.portalId?.toString() ?? null,
  };
};
